import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// External Components
import Container from './Container/index.js';

ReactDOM.render(<Container />, document.getElementById('root'));